import { render, staticRenderFns } from "./AccountInvitation.vue?vue&type=template&id=4b615711&scoped=true&"
import script from "./AccountInvitation.vue?vue&type=script&lang=js&"
export * from "./AccountInvitation.vue?vue&type=script&lang=js&"
import style0 from "./AccountInvitation.vue?vue&type=style&index=0&id=4b615711&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b615711",
  null
  
)

export default component.exports